<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 1V8M8 8V15M8 8H1M8 8H15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke="#07092C"/>
</svg>
